// The US and Canada's shared +1 numbering plan (NANP; Step 2 round 3), with no imports, so the app reads numbers by
// the very same rule as the server (src/calls.ts).

// A US or Canadian number as typed ("(512) 555-0142", "512.555.0142", "+1 512 555 0142", "1-512-555-0142") in +1
// form, or null. Only the first number in the text is read; another country's ("+44 …") is null.
export function nanpNumber(raw: string): string | null {
  const m = raw.match(/(?:\+|00)?[\d\s().-]{10,}/)
  if (!m) return null
  const hasPlus = /^\s*(\+|00)/.test(m[0])
  let digits = m[0].replace(/\D/g, '')
  if (hasPlus && m[0].trim().startsWith('00')) digits = digits.slice(2)
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1)
  else if (hasPlus) return null
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? `+1${digits}` : null
}

// The +1 numbers a US or Canadian round's call may ring: the US and Canada only. Not the Caribbean countries, Bermuda
// or the US territories that share +1 (priced apart, and a favourite of toll fraud, as the Channel Islands are in the
// UK), not 900 premium lines or 976 numbers, not personal (5xx), Canadian non-geographic (600, 622), 700 or 710
// numbers, not N11 service codes. Toll-free (800, 833 to 888) is fine to ring.
const NANP_ABROAD = new Set(['242', '246', '264', '268', '284', '340', '345', '441', '473', '649', '658', '664', '670', '671', '684', '721', '758', '767', '784', '787', '809', '829', '849', '868', '869', '876', '939'])
const NANP_NOT_CALLED = new Set(['456', '500', '521', '522', '523', '524', '525', '526', '527', '528', '529', '532', '533', '535', '538', '542', '543', '544', '545', '546', '547', '549', '550', '566', '577', '588', '600', '622', '700', '710', '900'])
export function dialableNanp(e164: string): boolean {
  const m = /^\+1([2-9]\d{2})([2-9]\d{2})\d{4}$/.exec(e164)
  if (!m) return false
  const [, area, exchange] = m as unknown as [string, string, string]
  if (NANP_ABROAD.has(area) || NANP_NOT_CALLED.has(area) || exchange === '976') return false
  return !/^[2-9]11$/.test(area) && !/^[2-9]11$/.test(exchange)
}
